<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}资产卡片</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">卡片基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="卡片号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成卡片号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="关联合同" prop="contractNo">
                <el-select :disabled="!editMode" v-model="form.contractNo" style="width: 90%" filterable clearable placeholder="请选择关联合同" :filter-method="getContracts" @change="contractChange">
                  <el-option v-for="item in STATIC_Contracts" :key="item.id" :label="item.contractNo + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            {{ form.fixedAssetNo }}
            <el-col :span="6">
              <el-form-item label="资产编码" prop="fixedAssetNo">
                <SelectTable style="width: 90%" :disabled="!editMode" :columns="stockColumns2" :placeholder="'请选择资产编码'" :innerName="form.fixedAssetNo" :dataList="assetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="fixedAssetName">
                <el-input v-model="form.fixedAssetName" disabled placeholder="系统自动带出资产名称" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input v-model="form.specName" disabled placeholder="系统自动带出规格型号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产单位" prop="unitName">
                <el-input v-model="form.unitName" disabled placeholder="系统自动带出资产单位" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产品牌" prop="brandName">
                <el-input v-model="form.brandName" disabled placeholder="系统自动带出资产品牌" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="form.number" :min="0" :controls="false" placeholder="请填写数量" style="width: 90%" @change="numberChange"></el-input-number>
                <!-- <el-input v-model="form.number" :disabled="!editMode" placeholder="请填写数量" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="初始金额" prop="amount">
                <el-input-number disabled v-model="form.amount" :min="0" :precision="4" :controls="false" placeholder="请填写初始金额" style="width: 90%"></el-input-number>
                <!-- <el-input v-model="form.amount" disabled placeholder="请填写初始金额" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="添置日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择添置日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出厂编号" prop="factoryNo">
                <el-input v-model="form.factoryNo" :disabled="!editMode" placeholder="请填写出厂编号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出厂日期" prop="factoryDate">
                <el-date-picker :disabled="!editMode" v-model="form.factoryDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择出厂日期" :picker-options="{
                    disabledDate(v) {
                      return factoryDateDisabled(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="归属库房" prop="warehouseName">
                <el-input v-model="form.warehouseName" disabled placeholder="系统自动带出归属库房" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input v-model="form.productionPlaceName" disabled placeholder="系统自动带出产地类型" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input v-model="form.assetTypeName" disabled placeholder="系统自动带出资产类型" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="财务分类" prop="financeTypeName">
                <el-input disabled v-model="form.financeTypeName" placeholder="系统自动带出财务分类" style="width: 90%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="注册证号" prop="certNo">
                <el-input disabled v-model="form.certNo" placeholder="系统自动带出注册证号" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否计量资产" prop="isMeteringSign">
                <el-select v-model="form.isMeteringSign" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否医疗资产" prop="isMedical">
                <el-select v-model="form.isMedical" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否特种资产" prop="isSpecial">
                <el-select v-model="form.isSpecial" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="是否急救资产" prop="isFirstAid">
                <el-select v-model="form.isFirstAid" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否效益资产" prop="isBenefit">
                <el-select v-model="form.isBenefit" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否房屋建筑" prop="isBuilding">
                <el-select disabled v-model="form.isBuilding" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-if="form.isBuilding != 1" label="配件" prop="parts">
                <el-input disabled v-model="form.parts" placeholder="请填写配件" style="width: 90%"></el-input>
              </el-form-item>
              <el-form-item v-else label="面积（㎡）" prop="area">
                <el-input disabled v-model="form.area" placeholder="请填写面积" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="采购人员" prop="purchaseUserName">
                <el-select :disabled="!editMode" v-model="form.purchaseUserName" style="width: 90%" filterable placeholder="请选择采购人员" :filter-method="getUsers" @change="purchaseUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收人员" prop="checkUserName">
                <el-select :disabled="!editMode" v-model="form.checkUserName" style="width: 90%" filterable placeholder="请选择资产验收人" :filter-method="getUsers" @change="checkUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品来源" prop="assetSource">
                <!-- <el-input
                  disabled
                  v-model="form.assetSourceName"
                  placeholder="系统自动带出产品来源"
                /> -->
                <el-select disabled v-model="form.assetSource" style="width: 90%" filterable placeholder="请选择产品来源" :filter-method="getProductSource">
                  <el-option v-for="item in STATIC_ProductSource" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保修标志" prop="isGuarantee">
                <el-select v-model="form.isGuarantee" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="保修到期日期" prop="guaranteeDate">
                <el-date-picker :disabled="!(editMode && form.isGuarantee == 1)" v-model="form.guaranteeDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择保修到期日期" :picker-options="{
                    disabledDate(v) {
                      return receivingDisabledDate(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养标志" prop="isMaintain">
                <el-select v-model="form.isMaintain" placeholder="请选择状态" style="width: 90%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养到期日期" prop="maintainDate">
                <el-date-picker :disabled="!(editMode && form.isMaintain == 1)" v-model="form.maintainDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择保养到期日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="更新时间" prop="updateTime">
                <el-input v-model="form.updateTime" disabled placeholder="系统自动带出更新时间" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <template v-for="(item, index) in form.details">
              <div :key="index">
                <el-col :span="6">
                  <el-form-item prop="capitalSourceName">
                    <label slot="label">
                      <span>{{
                        "资金来源(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span v-if="editMode" style="margin-left: 20px" class="color-blue pointer" type="text" v-preventReClick @click="removeCapitalSource(item)">删除</span>
                    </label>

                    <el-select :disabled="!editMode" v-model="item.capitalSourceName" placeholder="请选择资金来源" style="width: 90%" filterable :filter-method="getCapitalSources" @change="csChange(item)">
                      <el-option v-for="item in STATIC_CapitalSources" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="比例/金额">
                    <SeparateInput :disabled="!editMode" :left="item.ratio" :right="item.amount" :maxRight="form.amount ? form.amount : 0" @change="(left, right) => ratioChange(item, left, right)" style="width: 90%"></SeparateInput>
                  </el-form-item>
                </el-col>
              </div>
            </template>
          </el-row>

          <div v-if="editMode" style="cursor: pointer; margin-left: 10px; width: 96px" v-preventReClick @click="addCapitalSource">
            <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
            <span style="font-size: 13px; color: #286ab4; margin-left: 5px">添加资金来源</span>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传附件" prop="fileInfos"> </el-form-item>
              <!-- <my-upload
                  :canEdit="editMode"
                  @filesChange="filesChange"
                  :isLimitMaxSiz="true"
                  :oldList="form.fileInfos"
                ></my-upload> -->
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :showLabel="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">发票信息</span>
          </div>

          <!-- <el-form
            label-position="top"
            label-width="80px"
            ref="childPaymentForm"
            :model="form"
          > -->
          <template v-for="(row, index) in form.payInfoDetails">
            <el-row :key="index">
              <!-- <el-col :span="6">
                  <el-form-item prop="paymentRatio">
                    <label slot="label">
                      <span>{{
                        "首付日期（%）(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span
                        style="margin-left: 50px"
                        v-if="editMode"
                        class="color-blue pointer"
                        type="text"
                        v-preventReClick
                        @click="removePaymentInfo(row)"
                        >删除</span
                      >
                    </label>
                    <el-date-picker
                      :disabled="!editMode"
                      v-model="row.firstDate"
                      style="width: 90%"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择首付日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="尾款日期" prop="paymentDate">
                    <el-date-picker
                      :disabled="!editMode"
                      v-model="row.endDate"
                      style="width: 90%"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择尾款日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col> -->

              <el-col :span="6">
                <el-form-item prop="billNoId">
                  <label slot="label">
                    <span>{{
                      "发票号码(" + Arabia_To_SimplifiedChinese(index + 1) + ")"
                    }}</span>
                    <span v-if="editMode" style="margin-left: 20px" class="color-blue pointer" type="text" v-preventReClick @click="removePayInfo(row)">删除</span>
                  </label>
                  <el-select :disabled="!editMode" v-model="row.billNoId" placeholder="请选择发票号码" style="width: 90%" :filter-method="getPurchaseInvoicesData" @change="PurchaseInvoicesChange(row, $event)">
                    <el-option v-for="item in STATIC_PurchaseInvoicesData" :key="item.id" :label="item.no" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开票日期" prop="date">
                  <el-date-picker disabled v-model="row.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统自动带出开票日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发票金额" :prop="'payInfoDetails.' + index + '.billAmount'" :rules="payInfoRules.billAmount">
                  <el-input-number :disabled="!editMode" v-model="row.billAmount" :min="0" :precision="4" :controls="false" placeholder="请填写发票金额" style="width: 90%"></el-input-number>
                  <!-- <el-input v-model="row.billAmount" :disabled="!editMode" placeholder="请填写发票金额" style="width:90%"></el-input> -->
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <div v-if="editMode" style="cursor: pointer; margin-left: 10px; width: 96px" v-preventReClick @click="addPaymentInfo">
            <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
            <span style="font-size: 13px; color: #286ab4; margin-left: 5px">添加发票</span>
          </div>
          <!-- </el-form> -->
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">折旧信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="折旧规则" prop="depreciationId">
                <el-select :disabled="!editMode" v-model="form.depreciationId" placeholder="请选择折旧规则" style="width: 90%" @change="calcDepreciation">
                  <el-option v-for="item in STATIC_Depreciations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计使用寿命（月）" prop="serviceLifeMonth">
                <el-input-number :disabled="!editMode" v-model="form.serviceLifeMonth" :min="0" :precision="1" :controls="false" placeholder="请填写预计使用寿命" style="width: 90%" @change="calcDepreciation"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.serviceLifeMonth" placeholder="请填写预计使用寿命" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计净残值率（%）" prop="netSalvage">
                <el-input-number :disabled="!editMode" v-model="form.netSalvage" :min="0" :max="100" :precision="2" :controls="false" placeholder="请填写预计净残值率" style="width: 90%" @change="calcDepreciation('netSalvage')"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.netSalvage" placeholder="请填写预计净残值率" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计总工作量" prop="totalWorkload">
                <el-input-number :disabled="!editMode" v-model="form.totalWorkload" :min="0" :precision="2" :controls="false" placeholder="请填写预计总工作量" style="width: 90%" @change="calcDepreciation"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.totalWorkload" placeholder="请填写预计总工作量" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="预计资产净残值" prop="salvage">
                <el-input-number :disabled="!editMode" v-model="form.salvage" :min="0" :max="form.amount ? form.amount : 0" :precision="4" :controls="false" placeholder="请填写预计资产残值" style="width: 90%" @change="calcDepreciation('salvage')"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.salvage" placeholder="请填写预计资产残值" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="折旧开始日期" prop="startDate">
                <el-date-picker :disabled="!editMode" v-model="form.startDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择折旧开始日期" @change="startDateChange" :picker-options="{
                    disabledDate(v) {
                      return startDateDisabledDate(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="已折旧年份（月）" prop="depreciatedYear">
                <el-input-number disabled v-model="form.depreciatedYear" :min="0" :precision="1" :controls="false" placeholder="请填写已折旧年份" style="width: 90%" @change="calcDepreciation"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.DepreciatedYear" placeholder="请填写已折旧年份" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月平均折旧额" prop="avgDepreciation">
                <el-input-number disabled v-model="form.avgDepreciation" :min="0" :precision="4" :controls="false" placeholder="请填写月平均折旧额" style="width: 90%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.avgDepreciation" placeholder="请填写月平均折旧额" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="已累计折旧额" prop="cumulativeDepreciation">
                <el-input-number disabled v-model="form.cumulativeDepreciation" :min="0" :precision="4" :controls="false" placeholder="请填写已累计折旧额" style="width: 90%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.cumulativeDepreciation" placeholder="请填写已累计折旧额" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产净残值" prop="assetNetSalvage">
                <el-input-number disabled v-model="form.assetNetSalvage" :min="0" :precision="4" :controls="false" placeholder="请填写资产净残值" style="width: 90%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.assetNetSalvage" placeholder="请填写资产净残值" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">使用信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="责任科室" prop="dutyDeptName">
                <el-select :disabled="!editMode" v-model="form.dutyDeptName" placeholder="请选择责任科室" style="width: 90%" filterable :filter-method="getDepts" @change="dutyDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="责任人" prop="dutyUserName">
                <el-select :disabled="!editMode" v-model="form.dutyUserName" placeholder="请选择责任人" style="width: 90%" filterable :filter-method="getUsers" @change="dutyUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用科室" prop="deptName">
                <el-select disabled v-model="form.deptName" placeholder="请选择使用科室" style="width: 90%" filterable :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用人" prop="deptUserName">
                <el-select disabled v-model="form.deptUserName" placeholder="请选择使用人" style="width: 90%" filterable :filter-method="getUsers" @change="deptUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="保管人" prop="CustodianName">
                <el-select disabled v-model="form.CustodianName" placeholder="请选择保管人" style="width: 90%" filterable :filter-method="getUsers" @change="custodianChange">
                  <el-option v-for="item in CustodianUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="存放地点" prop="address">
                <el-input v-model="form.address" disabled placeholder="请填写存放地点" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">厂商信息</span>
          </div>

          <div style="margin: 10px; background-color: white; padding-top: 10px">
            <span style="font-weight: bold; font-size: 14px; margin-left: 10px">供应商</span>
            <el-row>
              <el-col :span="6">
                <el-form-item label="供应商" prop="supplierName">
                  <el-select disabled v-model="form.supplierName" placeholder="系统自动带出供应商" style="width: 90%" filterable :filter-method="getSuppliers" @change="supplierChange">
                    <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商编码" prop="supplierNo">
                  <el-input v-model="form.supplierNo" disabled placeholder="系统自动带出供应商编码" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式" prop="supplierPhone">
                  <el-input v-model="form.supplierPhone" disabled placeholder="系统自动带出联系方式" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系人" prop="supplierContactor">
                  <el-input v-model="form.supplierContactor" disabled placeholder="系统自动带出联系人" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div style="margin: 10px; background-color: white; padding-top: 10px">
            <span style="font-weight: bold; font-size: 14px; margin-left: 10px">生产厂家</span>
            <el-row>
              <el-col :span="6">
                <el-form-item label="生产厂家" prop="manufacturerName">
                  <el-select disabled v-model="form.manufacturerName" placeholder="系统自动带出生产厂家" style="width: 90%" filterable :filter-method="getManufacturers" @change="manufacturerChange">
                    <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="厂商编码" prop="manufacturerNo">
                  <el-input v-model="form.manufacturerNo" disabled placeholder="系统自动带出厂商编码" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式" prop="manufacturerPhone">
                  <el-input v-model="form.manufacturerPhone" disabled placeholder="系统自动带出联系方式" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系人" prop="manufacturerContactor">
                  <el-input v-model="form.manufacturerContactor" disabled placeholder="系统自动带出联系人" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div style="margin: 10px; background-color: white; padding-top: 10px">
            <span style="font-weight: bold; font-size: 14px; margin-left: 10px">维修厂商</span>
            <el-row>
              <el-col :span="6">
                <el-form-item label="维修厂商" prop="repairManufacturerName">
                  <el-select :disabled="!editMode" v-model="form.repairManufacturerName" placeholder="请选择维修厂商" style="width: 90%" filterable :filter-method="getRepairManufacturers" @change="repairManufacturerChange">
                    <el-option v-for="item in STATIC_RepairManufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="厂商编码" prop="repairManufacturerNo">
                  <el-input v-model="form.repairManufacturerNo" disabled placeholder="系统自动带出厂商编码" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式" prop="repairManufacturerPhone">
                  <el-input v-model="form.repairManufacturerPhone" :disabled="!editMode" placeholder="请填写联系方式" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系人" prop="repairManufacturerContactor">
                  <el-input v-model="form.repairManufacturerContactor" :disabled="!editMode" placeholder="请填写联系人" style="width: 90%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetAssetCardById,
  SaveAssetCard,
  GetStocksByContract,
  GetManufacturerById,
  GetSupplierById,
  GetStockByDetailId,
  RejectAssetCard,
  GetFixedAssetById,
} from "@/api";
import { WhetherOptions } from "@/enum";
// import Address from '@/components/address';
// import ElImageViewer from '@/components/elImageViewer'
import SelectTable from "@/components/select-table";
import SeparateInput from "@/components/separate-input";
import UploadFileList from "@/components/upload-file-list";
import { Arabia_To_SimplifiedChinese } from "@/utils/number.js";
import MyUpload from "@/components/my-upload";
import { depreciation } from "@/utils/depreciation.js";
import ApproveInfo from "@/components/approve-info";
import { GetContractByIdAssetId } from "@/api";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    SeparateInput,
    MyUpload,
    ApproveInfo,
    UploadFileList,
  },
  data () {
    return {
      form: {},
      WhetherOptions: WhetherOptions,
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      depreciation: depreciation,
      rules: {
        // contractNo: [
        //   { required: true, message: "关联合同不能为空", trigger: "blur" },
        // ],
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        checkUserName: [
          { required: true, message: "验收人不能为空", trigger: "blur" },
        ],
        purchaseUserName: [
          { required: true, message: "采购人员不能为空", trigger: "blur" },
        ],
        number: [
          {
            validator: this.cardNumberValidate,
            tigger: "blur",
          },
        ],
        data: [
          { required: true, message: "添置日期不能为空", trigger: "blur" },
        ],
        factoryNo: [
          { required: true, message: "出厂编号不能为空", trigger: "blur" },
        ],
        factoryDate: [
          { required: true, message: "出厂日期不能为空", trigger: "blur" },
        ],
        depreciationId: [
          { required: true, message: "折旧规则不能为空", trigger: "blur" },
        ],
        serviceLifeMonth: [
          { required: true, message: "预计使用寿命不能为空", trigger: "blur" },
          {
            required: true,
            validator: this.serviceLifeMonthValidate,
            tigger: "blur",
          },
        ],
        netSalvage: [
          { required: true, message: "预计净残值率不能为空", trigger: "blur" },
        ],
        totalWorkload: [
          { required: true, message: "预计总工作量不能为空", trigger: "blur" },
        ],
        salvage: [
          { required: true, message: "预计资产残值不能为空", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "折旧开始日期不能为空", trigger: "blur" },
        ],
        dutyDeptName: [
          { required: true, message: "责任科室不能为空", trigger: "blur" },
        ],
        dutyUserName: [
          { required: true, message: "责任人不能为空", trigger: "blur" },
        ],
        // depreciatedYear: [
        //   { required: true, message: "已折旧年份不能为空", trigger: "blur" },
        // ],
        // avgDepreciation: [
        //   { required: true, message: "月平均折旧额不能为空", trigger: "blur" },
        // ],
        // cumulativeDepreciation: [
        //   { required: true, message: "已累计折旧额不能为空", trigger: "blur" },
        // ],
        // assetNetSalvage: [
        //   { required: true, message: "资产净残值不能为空", trigger: "blur" },
        // ],
      },
      payInfoRules: {
        billAmount: [
          {
            validator: this.billAmountValidate,
            tigger: "blur",
          },
        ],
      },
      editMode: false,
      assetList: [],
      reject: RejectAssetCard,

      category: 0,

      CustodianUsers: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
      if (query.assetStockId) {
        this.assetChange(query.assetStockId);
      }
    }

    if (query.category != 0) {
      this.category = query.category;
      this.form.category = query.category;
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }
    this.defaultAllQueryParams.ContractCategoryId = 0;
    this.getUsers("");
    this.getContracts("");
    this.getDepts("");
    this.getManufacturers("");
    this.getSuppliers("");
    this.getRepairManufacturers("");
    this.getCapitalSources("");
    this.getDepreciations();
    this.getProductSource();
    this.getPurchaseInvoicesData();
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.getFixedAssetList();
    },
    // 编辑
    handleUpdate (id) {
      GetAssetCardById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getFixedAssetList();

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let amount = 0;
        this.form.payInfoDetails.forEach((t) => {
          amount += t.billAmount;
        });
        if (amount > this.form.amount) {
          this.$my_message(`发票总金额不能超过建卡资产的金额`, "warning");
          return false;
        }
        SaveAssetCard(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        checkUserName: "",
        checkUserId: "",
        checkRange: 0,
        category: this.category,
        name: "",
        state: 0,
        isRepairSign: 0,
        isMeteringSign: 0,
        isBenefit: 0,
        isFirstAid: 0,
        isMedical: 0,
        isSpecial: 0,
        // "isBuilding": 0,
        isGuarantee: 0,
        isMaintain: 0,
        guaranteeDate: "",
        maintainDate: "",
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
        details: [{ $index: 1, ratio: 0, amount: 0 }],
        payInfoDetails: [{ $index: 1, billAmount: 0, billNo: "" }],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        no: "",
        contractId: "",
        assetId: 0,
        specName: "",
        date: "",
        factoryNo: "",
        factoryDate: "",
        warehouseId: "",
        productionPlace: "",
        assetTypeId: "",
        financeTypeId: "",
        certId: "",
        isBuilding: 0,
        parts: "",
        area: 0,
        checkUserId: "",
        purchaseUserId: "",
        assetSource: "",
        depreciationId: "",
        serviceLife: 0,
        netSalvage: 0,
        totalWorkload: 0,
        salvage: 0,
        startDate: this.parseTime(new Date()),
        depreciatedYear: 0,
        avgDepreciation: "",
        cumulativeDepreciation: "",
        assetNetSalvage: "",
        deptId: "",
        deptUserId: "",
        dutyDeptId: "",
        dutyUserId: "",
        address: "",
        supplierId: "",
        supplierContactor: "",
        supplierPhone: "",
        manufacturerId: "",
        manufacturerContactor: "",
        manufacturerPhone: "",
        repairManufacturerId: "",
        repairManufacturerContactor: "",
        repairManufacturerPhone: "",
        orgCode :sessionStorage.getItem('orgId')
      };

      this.startDateChange();
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      //   // this.$router.push({ name: '资产建卡', params: { category: this.category } });
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // 资金来源
    addCapitalSource () {
      if (!this.form.details) {
        this.$set(this.form, "details", []);
      }

      this.form.details.push({
        $index: this.form.details.length + 1,
        ratio: 0,
        amount: 0,
      });
    },
    removeCapitalSource (item) {
      this.form.details = this.form.details.filter(
        (i) => item.$index != i.$index
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    removePayInfo (item) {
      this.form.payInfoDetails = this.form.payInfoDetails.filter(
        (i) => item.$index != i.$index
      );
      this.form.payInfoDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    ratioChange (item, left, right) {
      item.left = left;
      item.right = right;

      // let changeRatio = true; // 改变的是否为比例
      // if (left == detail.ratio) {
      //   changeRatio = false;
      // }
      // detail.ratio = left;
      // detail.amount = right;

      // if (changeRatio) {
      //   detail.amount = ((this.form.amount * left) / 100).toFixed(2) * 1;
      // } else {
      //   detail.ratio = ((right / this.form.amount) * 100).toFixed(2) * 1;
      // }
    },
    csChange (item) {
      item.capitalSourceId = item.capitalSourceName;
      let obj = this.STATIC_CapitalSources.find(
        (e) => e.id == item.capitalSourceId
      );
      if (obj) {
        item.capitalSourceName = obj.name;
      }
    },

    // 发票信息
    addPaymentInfo () {
      if (!this.form.payInfoDetails) {
        this.$set(this.form, "payInfoDetails", []);
      }

      this.form.payInfoDetails.push({
        $index: this.form.payInfoDetails.length + 1,
        billAmount: 0,
        billNo: "",
      });
    },
    removePaymentInfo (item) {
      this.form.payInfoDetails = this.form.payInfoDetails.filter(
        (i) => item.$index != i.$index
      );
      this.form.payInfoDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },

    // change event
    assetChange (id) {
      GetStockByDetailId({ detailId: id }).then((res) => {
        if (res.returnData) {
          this.selectAsset(res.returnData);
        }
      });
    },
    selectAsset (row) {
      var item = this.STATIC_Contracts.find(
        (t) => t.id == this.form.contractId
      );
      if (this.form.contractId) {
        this.getConAssetInfo(this.form.contractId, row.assetId, item.name);
      }
      this.form = Object.assign(this.form, row, {
        isRepairSign: 0,
        isMeteringSign: 0,
        isBenefit: 0,
        isFirstAid: 0,
        isMedical: 0,
        isSpecial: 0,
        remark: "",
        id: this.form.id,
        number: 1,
        amount: row.price * 1,
        stockState: row.state,
      });
      GetFixedAssetById({ id: row.assetId }).then((res) => {
        // 获取折旧规则
        this.form.depreciationId = res.returnData.depreciationId;
        this.form.serviceLifeMonth = res.returnData.serviceLife;
        this.form.netSalvage = res.returnData.netSalvage;
        this.form.totalWorkload = res.returnData.totalWorkload;
        this.form.salvage = res.returnData.salvage;
      });
      this.manufacturerChange(this.form.manufacturerId);
      this.supplierChange(this.form.supplierId);
    },
    contractChange (val) {
      var item = this.STATIC_Contracts.find((t) => t.id == val);
      this.form.contractId = val;
      if (this.form.assetId) {
        this.getConAssetInfo(val, this.form.assetId, item.name);
      }

      this.getFixedAssetList();
    },
    getConAssetInfo (contractId, assetId, contractName) {
      GetContractByIdAssetId({
        id: contractId,
        assetId: assetId,
      }).then((res) => {
        window.console.log(res);
        if (res.returnData) {
          if (res.returnData.details) {
            this.form.factoryDate = res.returnData.details[0].productionDate;
            this.form.date = res.returnData.arrivalDate;
            if (res.returnData.details[0].warranty) {
              this.form.isGuarantee = 1;
              this.form.guaranteeDate = this.addMonthF(
                new Date(this.form.date),
                res.returnData.details[0].warranty
              );
            }
          } else {
            this.$my_message(
              `当前资产不在合同《${contractName}》中，请重新选择`,
              "warning"
            );
          }
        } else {
          this.$my_message(
            `当前资产不在合同《${contractName}》中，请重新选择`,
            "warning"
          );
        }
      });
    },
    numberChange () {
      this.form.amount = this.form.number * this.form.price;
      this.calcDepreciation();
    },
    checkUserChange (val) {
      this.form.checkUserId = val;
    },
    purchaseUserChange (val) {
      this.form.purchaseUserId = val;
    },
    supplierChange (val) {
      this.form.supplierId = val;
      GetSupplierById({ id: val }).then((res) => {
        if (res.returnData) {
          this.form.supplierNo = res.returnData.no;
          this.form.supplierPhone = res.returnData.phone;
          this.form.supplierContactor = res.returnData.contactor;
        } else {
          this.form.supplierNo = "";
          this.form.supplierPhone = "";
          this.form.supplierContactor = "";
        }
      });
      // this.form.supplierId = val

      // let item = this.STATIC_Suppliers.find(item => item.id == val)
      // if (item) {
      //   this.form.supplierNo = item.no
      //   this.form.supplierPhone = item.phone
      //   this.form.supplierContactor = item.contactor
      // }
    },
    manufacturerChange (val) {
      this.form.manufacturerId = val;
      GetManufacturerById({ id: val }).then((res) => {
        if (res.returnData) {
          this.form.manufacturerNo = res.returnData.no;
          this.form.manufacturerPhone = res.returnData.phone;
          this.form.manufacturerContactor = res.returnData.contactor;
        } else {
          this.form.manufacturerNo = "";
          this.form.manufacturerPhone = "";
          this.form.manufacturerContactor = "";
        }
      });
    },
    repairManufacturerChange (val) {
      this.form.repairManufacturerId = val;

      let item = this.STATIC_RepairManufacturers.find((item) => item.id == val);
      if (item) {
        this.form.repairManufacturerNo = item.no;
        this.form.repairManufacturerPhone = item.phone;
        this.form.repairManufacturerContactor = item.contactor;
      }
    },
    deptUserChange (val) {
      this.form.deptUserId = val;
    },
    deptChange (val) {
      this.form.deptId = val;
      this.getUsersByDept();
    },
    dutyDeptChange (val) {
      this.form.dutyDeptId = val;
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    custodianChange (val) {
      this.form.CustodianId = val;
    },
    getUsersByDept (val) {
      this.getDeptUsers(this.form.deptId, val).then((res) => {
        this.CustodianUsers = res;
      });
    },
    // netSalvageChange () {
    //   this.form.salvage = this.form.amount * this.form.netSalvage / 100
    //   this.calcDepreciation()
    // },
    startDateChange () {
      let date = new Date(this.form.startDate);
      let startYear = date.getFullYear();
      let startMonth = date.getMonth() + 1;
      let startDay = date.getDate();

      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();

      let months = (year - startYear) * 12 + (month - startMonth);
      if (day < startDay) {
        months--;
      }

      this.form.depreciatedYear = months;
      this.depreciation(this.form);
    },

    getFixedAssetList (keyWord) {
      GetStocksByContract({ contractId: this.form.contractId }).then((res) => {
        this.assetList = res.returnData;
      });
    },

    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
    PurchaseInvoicesChange (row, val) {
      let item = this.STATIC_PurchaseInvoicesData.find((t) => t.id == val);
      if (item) {
        row.PurchaseInvoiceId = item.id;
        row.billNo = item.no;
        row.billAmount = item.unTotalAmount;
        row.date = item.date;
      } else {
        row.PurchaseInvoiceId = "";
        row.billNo = "";
        row.billAmount = "";
        row.date = "";
      }
    },
    calcDepreciation (type) {
      if (type == "netSalvage") {
        this.form.salvage = (this.form.amount * this.form.netSalvage) / 100;
      }
      if (type == "salvage") {
        this.form.netSalvage = (this.form.salvage / this.form.amount) * 100;
      }
      this.depreciation(this.form);
    },

    // validate
    serviceLifeMonthValidate (rule, value, callback) {
      if (
        (this.form.depreciationId == 3 || this.form.depreciationId == 4) &&
        value % 12 != 0
      ) {
        callback(new Error(`预计使用寿命应该是整年(12的倍数)`));
      }
      if (this.form.depreciationId == 3 && value < 24) {
        callback(new Error(`预计使用寿命不能小于24个月`));
      } else if (
        this.form.depreciatedYear &&
        value < this.form.depreciatedYear
      ) {
        callback(new Error(`预计使用寿命应该大于已折旧年份（月）`));
      } else {
        callback();
      }
    },
    receivingDisabledDate (v) {
      if (this.form.date) {
        return v.getTime() < new Date(this.form.date).getTime();
      } else {
        return false;
      }
    },
    factoryDateDisabled (v) {
      if (this.form.date) {
        return v.getTime() > new Date(this.form.date).getTime();
      } else {
        return false;
      }
    },
    startDateDisabledDate (v) {
      if (this.form.date) {
        return v.valueOf() < new Date(this.form.date).setHours(0, 0, 0, 0);
      } else {
        return false;
      }
    },
    // validate
    billAmountValidate (rule, value, callback) {
      if (!value || value == "" || value == 0) {
        callback(new Error(`发票金额不能为0`));
      } else {
        callback();
      }
    },
    cardNumberValidate (rule, value, callback) {
      if (!value || value == "") {
        callback(new Error(`建卡数量不能为空`));
      } else if (value == 0) {
        callback(new Error(`建卡数量不能为0`));
      } else if (this.form.unCardNumber < value) {
        callback(new Error(`建卡数量不能大于未建卡数量`));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.el-input-number .el-input__inner {
//   text-align: left !important;
// }
</style>
